import React from 'react';
import { Helmet } from 'react-helmet';

const SEOSchema = () => {
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://uvdmedia.com",
    "name": "UVD Media",
    "description": "Professional book trailer videos for authors. We help self-published authors, indie authors, and publishers create cinematic trailers that bring stories to life.",
    "url": "https://uvdmedia.com",
    "telephone": "+1-484-238-0658",
    "email": "info@uniquevisiondrones.com",
    "priceRange": "$$",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "109 Plowshare Rd",
      "addressLocality": "West Norriton",
      "addressRegion": "PA",
      "postalCode": "19403",
      "addressCountry": "US"
    },
    "areaServed": {
      "@type": "Country",
      "name": "United States"
    },
    "sameAs": [
      "https://www.facebook.com/profile.php?id=100089661190829",
      "https://www.youtube.com/@UniqueVisionDrones",
      "https://www.instagram.com/uvdmedia",
      "https://www.tiktok.com/@coachdooley"
    ],
    "founder": {
      "@type": "Person",
      "name": "Coach Dooley"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Book Trailer Video Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Book Trailer Video Production",
            "description": "Professional book trailer videos for authors - self-published, indie authors, Amazon authors"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Promotional Video Services",
            "description": "Product and service promotional videos for authors and small businesses"
          }
        }
      ]
    },
    "makesOffer": [
      {
        "@type": "Offer",
        "name": "Starter Package - Launch Essentials",
        "price": "250.00",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "name": "Pro Package - Story Builder",
        "priceCurrency": "USD"
      },
      {
        "@type": "Offer",
        "name": "Premium Package - Launch Campaign",
        "priceCurrency": "USD"
      }
    ]
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "UVD Media",
    "url": "https://uvdmedia.com",
    "logo": "https://uvdmedia.com/uvd-logo.png",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+1-484-238-0658",
      "contactType": "Customer Service",
      "email": "info@uniquevisiondrones.com",
      "areaServed": "US",
      "availableLanguage": "English"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
    </Helmet>
  );
};

export default SEOSchema;
